import React from 'react'
import './authors.styles.scss'
import Author from './author/author.component'

const Authors = props => {
    return (
        <div className="authors">
            {
                props.authors.map((author, key) => <Author manuscriptId={props.manuscriptId} key={key} {...author} onRemove={() => props.onRemove(author.id)}/>)
            }
        </div>
    )
}

export default Authors